import { Component, OnInit, AfterViewInit, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-sticky-header',
  template: '<ng-content></ng-content>'
})
export class StickyHeaderComponent implements OnInit, AfterViewInit {

  @Input('container') container: any;
  @Input('offset') offset: number = 0;
  @Input('zIndex') zIndex: number = 1000;

  element: any;
  end: number = 0;
  height: number = 0;
  start: number = 0;
  sticky: boolean = false;
  style: any;
  width: number = 0;

  constructor(private elementRef: ElementRef) { }

  ngOnInit() {
    this.element = this.elementRef.nativeElement;
  }

  ngAfterViewInit() {
    if (this.container == null) {
      this.container = this.element.parentNode;
    }
    let s = window.getComputedStyle(this.element)
    this.style = {
      height: s.height,
      position: s.position,
      top: s.top,
      width: s.width,
      zIndex: s.zIndex
    }
    setTimeout(() => {this.reset()},1)
  }

  reset() {
    let parent = this.element.parentNode;
    this.width = parent.clientWidth;
    this.height = parent.clientHeight;
    let containerRect = this.container.getBoundingClientRect();
    let offset = window.pageYOffset-this.offset;
    this.start = offset+containerRect.top;
    this.end = offset+containerRect.bottom;
    this.unstick();
    this.update();
  }

  update() {
    let offset = window.pageYOffset;
    if (offset > this.start && offset < this.end) {
      this.stick();
    } else {
      this.unstick();
    }
  }

  stick() {
    if (this.sticky) { return }
    Object.assign(this.element.style, {
      height: this.height+'px',
      position: 'fixed',
      top: this.offset+'px',
      width: this.width+'px',
      zIndex: this.zIndex
    });
    this.element.classList.add('sticky');
    this.sticky = true;
  }

  unstick() {
    if (!this.sticky) { return }
    Object.assign(this.element.style, this.style);
    this.element.classList.remove('sticky');
    this.sticky = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/sticky-header.component.ts